
import { useVoltage } from '../../hooks'

export default function LastVoltagePresenter() {
    const { lastVoltageQuery } = useVoltage()

    if (lastVoltageQuery.isError) {
      return <>Error</>
    }

    if (lastVoltageQuery.isLoading) {
      return <>...</>
    }

  return (
    <>{lastVoltageQuery?.data?.[0]?.Value || 'NA'}</>
  )
}
